import React from 'react';
import { Instagram, Youtube, Linkedin, Mail, Phone, MessageCircle } from 'lucide-react';
import { WHATSAPP } from '../mock';

const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-[#0a0a0c]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-14">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-10">
          <div>
            <div className="font-display font-bold text-2xl tracking-[0.15em] text-white">UNREAL VIZ</div>
            <p className="mt-4 text-neutral-400 max-w-sm leading-relaxed">
              La Masterclass italiana su Unreal Engine 5 per la visualizzazione architettonica. Un metodo. Una
              professione. Risultati concreti.
            </p>
            <div className="mt-6 flex gap-3">
              {[
                { icon: Instagram, href: 'https://www.instagram.com/unreal.viz/' },
                { icon: Youtube, href: 'https://www.youtube.com/@Unreal_Viz' },
                { icon: Linkedin, href: 'https://www.linkedin.com/in/unreal-viz-masterclass-for-high-quality-productions-62640a302/' },
              ].map((s, i) => (
                <a key={i} href={s.href} target="_blank" rel="noreferrer"
                  className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-neutral-300 hover:border-[var(--uv-gold)] hover:text-[var(--uv-gold)] transition-colors">
                  <s.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="label-mono !text-neutral-500">Contatti</div>
            <ul className="mt-5 space-y-4 text-neutral-300">
              <li>
                <a href={WHATSAPP} target="_blank" rel="noreferrer" className="inline-flex items-center gap-3 hover:text-[var(--uv-gold)] transition-colors">
                  <MessageCircle size={17} className="text-[var(--uv-gold)]" /> WhatsApp
                </a>
              </li>
              <li>
                <a href="mailto:info@unrealenginearchviz.com" className="inline-flex items-center gap-3 hover:text-[var(--uv-gold)] transition-colors">
                  <Mail size={17} className="text-[var(--uv-gold)]" /> info@unrealenginearchviz.com
                </a>
              </li>
              <li>
                <a href="tel:+393917027312" className="inline-flex items-center gap-3 hover:text-[var(--uv-gold)] transition-colors">
                  <Phone size={17} className="text-[var(--uv-gold)]" /> +39 391 70 27 312
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="label-mono !text-neutral-500">Menu</div>
            <ul className="mt-5 space-y-3 text-neutral-300">
              {['Home', 'Masterclass', 'Programma', 'About', 'Prezzi', 'Contatti'].map((m) => (
                <li key={m}>
                  <a href={`#${m.toLowerCase()}`} className="hover:text-[var(--uv-gold)] transition-colors">{m}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 text-sm text-neutral-500">
          © 2026 Unreal Viz. Tutti i diritti riservati.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
